import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";

// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
} from "@mui/material";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import PrizeDrawPrizeDialog from "src/components/prize-draw-admin/PrizeDrawPrizeDialog";
import { get } from "src/utils/networkUtils";

export default function PrizeDrawEntriesPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [rows, setRows] = useState(null);
  const [prizeEntry, setPrizeEntry] = useState(null);
  const [prizeDrawId, setPrizeDrawId] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has("prize_draw_id")) {
      setLoading(true);
      let prizeDrawId = searchParams.get("prize_draw_id");
      setPrizeDrawId(prizeDrawId);
      get(`/admin/prize-draws/${prizeDrawId}/entries?offset=0&limit=5000`).then(
        function (response) {
          setLoading(false);
          setRows(response.entries);
        }
      );
    } else {
      navigate("/404");
    }
  }, [setSearchParams, searchParams, navigate]);

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };
  const handleEditPrizeEntry = (userId) => {
    const prizeEntry = rows.find((item) => item.userId === userId);
    if (prizeEntry) {
      setPrizeEntry(prizeEntry);
    }
  };
  const downloadEntriesHandler = () => {
    get(`/admin/prize-draws/${prizeDrawId}`, { responseType: "blob" }).then(
      function (response) {
        const downloadUrl = window.URL.createObjectURL(new Blob([response]));

        const link = document.createElement("a");

        link.href = downloadUrl;

        link.setAttribute("download", "prize-draw-entries.csv");

        document.body.appendChild(link);

        link.click();

        link.remove();
      }
    );
  };
  return (
    <>
      <Helmet>
        <title> Prize Draw Entries </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Prize Draw Entries
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:arrow-circle-down-outline" />}
            onClick={() => downloadEntriesHandler()}
          >
            Download
          </Button>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Prize Draw ID</TableCell>
                      <TableCell>User ID</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>IsWinner</TableCell>
                      <TableCell>Prize</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.prizeDrawId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.userId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.amount}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.isWinner ? (
                            <Iconify
                              icon={"eva:checkmark-circle-2-outline"}
                              sx={{ color: "green" }}
                            />
                          ) : (
                            <Iconify
                              icon={"eva:close-circle-outline"}
                              sx={{ color: "red" }}
                            />
                          )}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.prizeText}
                        </TableCell>

                        <TableCell align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={handleOpenMenu}
                            id={row.userId}
                          >
                            <Iconify icon={"eva:more-vertical-fill"} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 180,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => handleEditPrizeEntry(openId)}>
          <Iconify icon={"eva:edit-outline"} sx={{ mr: 2 }} />
          Update Prize
        </MenuItem>
      </Popover>
      {prizeEntry !== null && (
        <PrizeDrawPrizeDialog
          open={true}
          setOpen={setOpen}
          prizeEntry={prizeEntry}
        />
      )}
    </>
  );
}
